





























































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { MemberTypeOption } from '@front-app/modules/group/components/admin/addMembers/addMembers';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import { syncedRef } from '@front-app/util/reactivity';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import BasicTextEditor from '@front-app/components/inputs/BasicTextEditor.vue';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { Routes } from '@front-app/constants/routes';
import { STATUS } from '@front-app/constants/state';
import { useStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		BasicTextEditor,
		CtaButton,
		ErrorCard,
		SimpleCard,
		SuccessCard,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
		selectedRole: {
			type: String as PropType<MemberTypeOption>,
			required: true,
		},
		numUsersAdded: {
			type: Number,
			required: true,
		},
		status: {
			type: String as PropType<STATUS>,
			default: STATUS.UNSTARTED,
		},
	},
	setup(props) {
		const emailText = syncedRef(() => getEmailBody(props.group, props.selectedRole)).ref;
		const toGroupMemberList = computed(() => ({ name: Routes.GROUP_ADMIN_MEMBER_MANAGEMENT }));
		const {
			isError,
			isLoading,
			isSuccess,
		} = useStatus(computed(() => props.status));

		return {
			toGroupMemberList,
			emailText,
			isError,
			isSuccess,
			isLoading,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});

function getEmailBody(group: GroupWithCommunity | undefined, role: UserRole): string {
	if (group) {
		if (role === UserRole.ADMINISTRATOR) {
			return `You have been invited to join the group ${group.name} as an administrator.`;
		}
		return `You're invited to join the ${group.name} group on TimedRight. It's a great way for healthcare professionals to share information, exchange knowledge, and network with peers. Just click the link to join.`;
	}
	if (role === UserRole.ADMINISTRATOR) {
		return 'You have been invited to a group as an administrator.';
	}
	return 'You have been invited to a group.';
}
